const tools = (state = false, action)=>{
    if(action.type === "SET_TOOLS_STATE"){
        state = action.state
    }
    if(action.type === "RESET_CANVAS"){
        state = false;
    }

    return state;
}

export default tools;